var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXmy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#EC1076"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8406 11.8125C11.502 11.8125 11.1302 11.6421 11.1302 11.1308C11.1302 10.8787 11.3271 10.1042 11.7197 8.8065C11.8001 8.60625 11.8401 8.42625 11.8401 8.26706C11.8401 7.9605 11.6038 7.65394 11.1639 7.65394C10.9086 7.65394 10.3523 7.75519 10.1835 8.30081C10.071 8.66475 9.81169 9.63056 9.40557 11.1988C9.24807 11.6078 8.96625 11.8125 8.56069 11.8125C7.95207 11.8125 7.85025 11.3692 7.85025 11.0964C7.85025 10.9884 8.01225 10.3354 8.33682 9.13894C8.46338 8.73956 8.52638 8.44875 8.52638 8.26706C8.52638 7.99425 8.32388 7.65394 7.85025 7.65394C7.37719 7.65394 6.93732 7.99425 6.73482 8.74406C6.59982 9.24469 6.408 9.9945 6.15994 10.9941C6.02494 11.5397 5.72007 11.8125 5.247 11.8125C4.81838 11.8125 4.59338 11.574 4.57088 11.0964L5.34825 7.85813H3.62419C3.51735 7.86185 3.41085 7.84416 3.31095 7.80611C3.21105 7.76806 3.11977 7.71041 3.04248 7.63655C2.9652 7.56269 2.90346 7.47412 2.86092 7.37605C2.81838 7.27798 2.79588 7.17239 2.79475 7.06549C2.79363 6.95859 2.8139 6.85255 2.85437 6.7536C2.89483 6.65466 2.95469 6.56481 3.0304 6.48934C3.10612 6.41387 3.19616 6.35431 3.29524 6.31416C3.39432 6.27401 3.50042 6.25409 3.60732 6.25556H6.498C6.90357 6.25556 7.15163 6.44906 7.24163 6.83494C7.64775 6.32419 8.18832 6.1875 8.6625 6.1875C9.13669 6.1875 9.74419 6.46031 10.0148 7.074C10.386 6.6645 11.0289 6.1875 11.9419 6.1875C12.7868 6.1875 13.4972 6.76687 13.4972 7.7895C13.4972 8.17594 13.3054 8.98313 12.9223 10.2105L14.4056 10.2004C14.8393 10.2004 15.1875 10.5615 15.1875 11.0064C15.1875 11.4514 14.8393 11.8125 14.4096 11.8125H11.8406Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmy);
export default __webpack_public_path__ + "static/media/xmy.ad42cd37a0dc2cbe4c260138b3301fbd.svg";
export { ForwardRef as ReactComponent };